import "./breakpoints/everyday_life_page.scss"; import "./everyday_life_page.scss"

